export default {
  LB: 'lbs',
  KG: 'kgs',
};
